import InfoTooltip from "components/Popup/InfoTooltip";
import { IStockOutputFinancials } from "Dashboard/scenes/Projects/domain/IStockOutputFinancials";
import { useSelector } from "react-redux";
import { FormatDateShort } from "utils/dateUtils";
import { FormatNumber, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { getStockOutputFinancials, selectState } from "../financials.slice";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";

interface IProps {
  data: IStockOutputFinancials | undefined;
  projectId: number;
}

const Stock = ({ data, projectId }: IProps) => {

  const dispatch = useAppDispatch();
  const { selectedDateFrom, selectedDateTo } = useSelector(selectState);

  useEffect(() => {
    const abortCtrl = new AbortController();
    if (projectId) {
      dispatch(getStockOutputFinancials({
        data: {
          projectId,
          from: selectedDateFrom,
          to: selectedDateTo
        },
        signal: abortCtrl.signal
      }));
    }
    return () => {
      if (projectId) {
        abortCtrl.abort();
      }
    };
  }, [
    dispatch,
    projectId,
    selectedDateFrom,
    selectedDateTo
  ]);

  return (
    <div>
      <h3><strong>LAGER</strong></h3>
      <section>
        <div className="projects-box-header lager-box">
          <div>
            <span className="right-align">suma</span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.costAmount, 'rsd')}
            </span>
          </div>
          <div>
            <span className="right-align">xxx</span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.costAmountXxx, 'rsd')}
            </span>
          </div>
        </div>
        <div className="projects-box-content">
          <div className="list-wrapp">
            {data?.entries &&
              data.entries.map((entry, index) => (
                <article key={index}>
                  <div className="col-1">
                    <span className="left strong">{entry.itemName}</span>
                  </div>
                  <div>
                    <span className="box-span right">
                      {entry.quantityAmount} {entry.quantityUnit.name}
                    </span>
                    <span className="light-color">izdato</span>
                    <span className="box-span">
                      {FormatDateShort(entry.date)}
                    </span>
                  </div>
                  <div>
                    <span className="box-span right">
                      {FormatNumber(entry.pricePerUnit)} rsd
                    </span>
                    <InfoTooltip
                      tooltip={entry.note}
                      classesProp="light-color grid-span-2 bg-text-overflow"
                      element="span"
                    >
                      cena &nbsp;&nbsp; {entry.note}
                    </InfoTooltip>
                  </div>
                </article>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Stock;
